{
    "CAIS-TID-Quick-Search-Fields": [
        {
            "label": "Report Date", "columnname": "reportDate", "placeholder": "Report Date",
            "width": "", "datatype": "DateRange", "isLarge": false, "fieldtype": "maskfield", "mask": "9999-99-99", "slotchar": "yyyy-mm-dd"
        },
        {
            "label": "In Customer Record ID", "columnname": "inCustomerRecordID", "placeholder": "In Customer Record ID",
            "width": "", "datatype": "String", "isLarge": false, "isXLarge": true 
        },
        {
            "label": "TID Type", "columnname": "tidType", "placeholder": "TID Type",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "TID Value", "columnname": "tidValue", "placeholder": "TID Value",
            "width": "", "datatype": "String", "isLarge": false, "isXLarge": true
        }
    ],
    "CAISTIDCols": [
        {
            "display": "false",
            "ui_columnname": "Id",
            "db_columnname": "id",
            "datatype": "char",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "rsmsStatus",
            "datatype": "char",
            "mappingkey": "rsmsStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 5
        },
        {
            "display": "false",
            "ui_columnname": "Firm",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 3
        },
        {
            "display": "false",
            "ui_columnname": "Active",
            "db_columnname": "active",
            "datatype": "String",
            "mappingkey": "active",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 4
        },
        {
            "display": "false",
            "ui_columnname": "Report Reason",
            "db_columnname": "reportReason",
            "datatype": "String",
            "mappingkey": "reportReason",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 6
        },
        {
            "display": "true",
            "ui_columnname": "In Customer RecordID",
            "db_columnname": "inCustomerRecordID",
            "datatype": "String",
            "mappingkey": "inCustomerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": true,
            "sortOrder": 7
        },
        {
            "display": "true",
            "ui_columnname": "TID Type",
            "db_columnname": "tidType",
            "datatype": "String",
            "mappingkey": "tidType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "isrequired": true,
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Type",
            "db_columnname": "foreignTIDType",
            "datatype": "String",
            "mappingkey": "foreignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 9
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Country",
            "db_columnname": "foreignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "foreignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "TID Value",
            "db_columnname": "tidValue",
            "datatype": "String",
            "mappingkey": "tidValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": true,
            "sortOrder": 11
        },
        {
            "display": "true",
            "ui_columnname": "Replaced By TID Type",
            "db_columnname": "replacedByTIDType",
            "datatype": "String",
            "mappingkey": "replacedByTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "sortOrder": 12
        },
        {
            "display": "true",
            "ui_columnname": "End Replacing Foreign TID Type",
            "db_columnname": "replacingForeignTIDType",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 13
        },
        {
            "display": "true",
            "ui_columnname": "Replacing Foreign TID Country",
            "db_columnname": "replacingForeignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Replaced By TID",
            "db_columnname": "replacedByTID",
            "datatype": "String",
            "mappingkey": "replacedByTID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Created User",
            "db_columnname": "createdUser",
            "datatype": "String",
            "mappingkey": "createdUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 15
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "updatedUser",
            "datatype": "String",
            "mappingkey": "updatedUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updatedDate",
            "datatype": "String",
            "mappingkey": "updatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 17
        }
    ]
}